import React from "react";
import { Popover } from "antd";
import profilePictureInfo from 'assets/images/profile-picture-info.svg';
import "./styles.less";

interface IProfilePhotoViewer {
  t: (key: string, params?: {}) => any;
}

const ProfilePhotoInfoPopover: React.FC<IProfilePhotoViewer> = (props) => {
  return (
    <Popover
      content={(
        <div className="photo__info__tooltip">
          <div className="photo__info__tooltip__title">
            {props.t('photo.profile_picture_title')}
          </div>
          <div className="photo__info__container">
            <img src={profilePictureInfo} alt="Photo Info" />
            <div className="photo__info__tooltip__description">
              {props.t('photo.profile_picture_info_description')}
            </div>
          </div>
        </div>
      )}
      placement='bottom'
      overlayInnerStyle={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '0px',
        width: '348px',
        height: '308px',
        background: '#FFFFFF',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        borderRadius: '4px'
      }}>
      {props.children}
    </Popover>
  );
};

export default ProfilePhotoInfoPopover;